export const testTheme = {
  fontFamily: "'Poppins', 'sans-serif'",
  pallette: {
    main: "red",
    black: {
      main: "#000000",
    },
    silver: {
      main: "#F0F2F8",
      light: "#4D536B",
      primary: "#0A1338",
      secondary: "#0A1338",
      dark: "#D8DCEB",
      text: "#667085",
    },
    dark: {
      main: "#101828",
    },
    blue: {
      main: "#18a43b",
      primary: "#148757",
      light: "#40a9ff",
      secondary: "#3B5998",
      link: "#00AEEF",
      border: "#1877F2",
    },
    white: {
      main: "#FFFFFF",
      primary: "#fafafa",
      light: "#f1fcff",
    },
    green: {
      main: "#00A560",
      primary: "#77B747",
      light: "#182353",
      secondary: "#0A1338",
      disabled: "#C9FFD6",
      chip: "#cdffcd",
      circle: "#007f00",
      dark: "#148757",
    },
    red: {
      main: "#EF4444",
      primary: "#EF4444",
      secondary: "#E22C2A",
      error: "#7F1D1D",
      light: "#fca5a5",
    },
    orange: {
      main: "#ff6347",
    },
    violet: {
      light: "#E9D7FE",
      main: "#6941C6",
    },
    yellow: {
      main: "#a17c0b",
    },
  },
  fontSizes: [12, 14, 16, 18, 24, 32, 36, 72, 96],
  space: [0, 4, 8, 16, 32, 64, 128, 256],

  public: {
    palette: {
      white: {
        main: "#FFFFFF",
        border: "#f3f7f8",
        light: "#f1fcff",
      },
      green: {
        primary: "#77B747",
        main: "#77b747",
        secondary: "#64AA30",
        shadow: "#86D7494C",
        gradient:
          "linear-gradient(146.34deg, rgb(119, 183, 71) 2.44%, rgb(112, 191, 53) 56.41%, rgb(119, 183, 71) 100%)",
      },
      silver: {
        main: "#707998",
        light: "#F5F8FA",
        text: "#707998",
        border: "#e2edef",
      },
      red: {
        main: "#df8481",
      },

      blue: {
        primary: "#182353",
        main: "#00AEEF",
        light: "#E2FDFF",
        secondary: "#70BEF8",
        third: "#82E1FF",
        hover: "#5363F4",
        link: "#00aeefb3",
        checkbox: "#039be5",
        border: "#b1e7f9",
        weak: "#EAF8FD",
        gradient: "linear-gradient(116.3deg, #5dc2e1 15.03%, #0596c4 66.45%)",
      },
    },
    buttons: {
      radius: "5px",
    },
  },

  buttons: {
    main: {
      color: "#182353",
      background: "#47FE75",
      radius: "100px",
      shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",

      hover: {
        background: "#18a43b",
        color: "#FFFFFF",
      },
    },

    secondary: {
      color: "#182353",
      background: "#FFFFFF",
      border: "#47FE75",
      radius: "100px",
      shadow: "none",

      hover: {
        background: "#18a43b",
        color: "#FFFFFF",
        border: "#18a43b",
      },
    },

    middle: {
      color: "#182353",
      background: "#C9FFD6",
      radius: "100px",
      shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",

      hover: {
        background: "#18a43b",
        color: "#FFFFFF",
      },
    },

    submit: {
      color: "#182353",
      background: "#47FE75",
      radius: "100px",
      shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      border: "#47FE75",

      hover: {
        background: "#0A1338",
        color: "#FFFFFF",
        border: "#0A1338",
      },

      focus: {
        background: "#47FE75",
        color: "#182353",
        border: "none",
      },

      disabled: {
        background: "#47FE75",
        color: "#182353",
        border: "#47FE75",
        opacity: "0.3",
      },
    },

    modalButton: {
      color: "#182353",
      background: "#47FE75",
      shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      border: "0",
      radius: "100px",

      reset: {
        background: "#C9FFD6",
        color: "#182353",
        shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
        hover: {
          background: "#0A1338",
          color: "#FFFFFF",
        },
      },

      hover: {
        background: "#0A1338",
        color: "#FFFFFF",
      },

      focus: {
        background: "#47FE75",
        color: "#182353",
        border: "none",
      },

      disabled: {
        background: "#47FE75",
        color: "#182353",
        opacity: "0.3",
      },
    },

    startHere: {
      background: "transparent",
      border: "#47FE75",
      color: "#47FE75",

      hover: {
        background: "transparent",
        color: "#FFFFFF",
        mainColor: "#182353",
        border: "transparent",
        borderColor: "#182353",
      },
    },
  },
};
